
export enum UserRoleName {
  manageCaptureAdmin = 'manage_capture_admin',
  manageUsers = 'manage_users',
  manageClients = 'manage_clients',
  accessReferralClaims = 'access_referral_claims',
  accessIccClaims = 'access_icc_claims',
  editVerifiedCaptures = 'edit_verified_captures',
  faxQueue = 'fax_queue',
  viewOcr = 'view_ocr',
  consultNoteUser = 'consult_note_user',
  manageClientChores = 'manage_client_chores',
  manageImplementation = 'manage_implementation',
  accessHieData = 'access_hie_data',
  manageClientConfigurations = 'manage_client_configurations',
  accessReportingAndTools = 'access_reporting_and_tools',
  manageProviderData = 'manage_provider_data',
  manageProduct = 'manage_product',
}

export const availableRoles = [
  // NOTE: manageCaptureAdmin is not an assignable role for the front end.
  {
    name: UserRoleName.manageUsers,
    humanizedName: 'Manage Client Users',
  },
  {
    name: UserRoleName.manageClients,
    humanizedName: 'Manage Clients',
  },
  {
    name: UserRoleName.accessReferralClaims,
    humanizedName: 'Referral Claims',
  },
  {
    name: UserRoleName.accessIccClaims,
    humanizedName: 'Ineligible Claims Capture',
  },
  {
    name: UserRoleName.editVerifiedCaptures,
    humanizedName: 'Edit Verified Captures',
  },
  {
    name: UserRoleName.faxQueue,
    humanizedName: 'Fax Queue',
  },
  {
    name: UserRoleName.viewOcr,
    humanizedName: 'View OCR',
  },
  {
    name: UserRoleName.consultNoteUser,
    humanizedName: 'Consult Note User',
  },
  {
    name: UserRoleName.manageClientChores,
    humanizedName: 'Manage Client Chores',
  },
  {
    name: UserRoleName.manageImplementation,
    humanizedName: 'Manage Implementation',
  },
  {
    name: UserRoleName.accessHieData,
    humanizedName: 'Access HIE Data',
  },
  {
    name: UserRoleName.manageClientConfigurations,
    humanizedName: 'Manage Client Configurations',
  },
  {
    name: UserRoleName.accessReportingAndTools,
    humanizedName: 'Reporting & Tools',
  },
  {
    name: UserRoleName.manageProviderData,
    humanizedName: 'Manage Provider Data',
  },
  {
    name: UserRoleName.manageProduct,
    humanizedName: 'Manage Product',
  }
];

export const searchableRoles = [
  {
    name: UserRoleName.manageCaptureAdmin,
    humanizedName: 'Manage Capture Admin',
  }
].concat(availableRoles).sort(
  (a, b) => a['humanizedName'].localeCompare(b['humanizedName'], 'en', { sensitivity: 'base' })
);
